"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartItemTypeToJSON = exports.CartItemTypeFromJSONTyped = exports.CartItemTypeFromJSON = exports.CartItemType = void 0;
/**
 *
 * @export
 */
exports.CartItemType = {
    Normal: 0,
    Overlay: 1
};
function CartItemTypeFromJSON(json) {
    return CartItemTypeFromJSONTyped(json, false);
}
exports.CartItemTypeFromJSON = CartItemTypeFromJSON;
function CartItemTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.CartItemTypeFromJSONTyped = CartItemTypeFromJSONTyped;
function CartItemTypeToJSON(value) {
    return value;
}
exports.CartItemTypeToJSON = CartItemTypeToJSON;
